import { getPhoneStyles } from './phone';
import { getTabletDesktopStyles } from './tablet-desktop/getTabletDesktopStyles';
export function getDeviceStyles(deviceType) {
  if (deviceType === 'phone') {
    return getPhoneStyles();
  }
  return getTabletDesktopStyles();
}